import ActionsForm from '@/shared/mixins/actionsForm'
import ModalAddObservation from './new/observation.vue'
import ObservationRepository from '@/shared/http/repositories/crm/observation'

export default {
  name: 'CrmDetailsObservation',
  mixins: [ActionsForm],
  props: {
    card: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      observations: [],
      showModal: false
    }
  },
  created () {
    this.onLoadObservations()
  },
  components: {
    ModalAddObservation
  },
  methods: {
    onLoad () {
    },
    onReload () {
      // this.$emit('Reload')
      this.showModal = false
      this.onLoadObservations()
    },
    onLoadObservations () {
      this.observations = []
      if (this.card && this.card.id) {
        ObservationRepository.GetByCardId(this.card.id)
          .then(response => {
            let responseData = response.data.content
            if (responseData.length > 0) {
              responseData.forEach(obs => {
                this.observations.push(obs)
              })
            }
          })
          .catch(this.onException)
      }
    },
    onAddObs () {
      this.showModal = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/observation/observation.js